import {
	BaseService as DMSBaseService,
	DropDownService as DMSComboboxService,
	CommandService as DMSCommandService,
	ExportService as DMSExportService,
	GridDefinitionService as DMSGridDefinitionService,
	LanguageService as DMSLanguageService,
	MenuService as DMSMenuService,
	PageTokenService as DMSPageTokenService,
	PeoplePickerService as DMSPeoplePickerService,
	ServiceProvider as DMSServiceProvider,
	TextBlockService as DMSTextBlockService,
	UserGridConfigService as DMSUserGridConfigService,
	UserService as DMSUserService,
} from "./index";

/**
 * ## Controls
 * List of all standard services.
 *
 * Please use the links below to navigate to the documentation of each service.
 */
export namespace Service {
	/**
	 * 
	 * Click {@link BaseService|here} for the documentation of BaseService.
	 */
	export const Base = DMSBaseService;
	/**
	 * @hidden
	 * Click {@link ComboboxService|here} for the documentation of ComboboxService.
	 */
	export const Combobox = DMSComboboxService;
	/**
	 * @hidden
	 * Click {@link CommandService|here} for the documentation of CommandService.
	 */
	export const Command = DMSCommandService;
	/**
	 * @hidden
	 * Click {@link ExportService|here} for the documentation of ExportService.
	 */
	export const Export = DMSExportService;
	/**
	 * @hidden
	 * Click {@link GridDefinitionService|here} for the documentation of GridDefinitionService.
	 */
	export const GridDefinition = DMSGridDefinitionService;
	/**
	 * @hidden
	 * Click {@link LanguageService|here} for the documentation of LanguageService.
	 */
	export const Language = DMSLanguageService;
	/**
	 * @hidden
	 * Click {@link MenuService|here} for the documentation of MenuService.
	 */
	export const Menu = DMSMenuService;
	/**
	 * @hidden
	 * Click {@link PageTokenService|here} for the documentation of PageTokenService.
	 */
	export const PageToken = DMSPageTokenService;
	/**
	 * @hidden
	 * Click {@link PeoplePickerService|here} for the documentation of PeoplePickerService.
	 */
	export const PeoplePicker = DMSPeoplePickerService;
	/**
	 * @hidden
	 * Click {@link ServiceProvider|here} for the documentation of ServiceProvider.
	 */
	export const Provider = DMSServiceProvider;
	/**
	 * 
	 * Click {@link TextBlockService|here} for the documentation of TextBlockService.
	 */
	export const TextBlock = DMSTextBlockService;
	/**
	 * @hidden
	 * Click {@link UserGridConfigService|here} for the documentation of UserGridConfigService.
	 */
	export const UserGridConfig = DMSUserGridConfigService;
	/**
	 * @hidden
	 * Click {@link UserService|here} for the documentation of UserService.
	 */
	export const User = DMSUserService;
}
